import React, { useRef, useState } from "react";
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';
import { useUploadCompanyWideAbsenceMutation, useUploadProviderAvailabilityMutation } from "../../../../../features/provider/providerApiSlice";
import { selectUser } from "../../../../../features/auth/authSlice";
import { useSelector } from "react-redux";
import ReusableModal from "../../../../../components/Modals/ReusableModal";


export default function UploadModal({ onClose, showAlert, fetchProviders }) {

    const [selectedType, setSelectedType] = useState("availability"); // null, "availability", "absences"
    const fileInputRef = useRef(null); // Reference to hidden file input
    const [fileName, setFileName] = useState(""); // Store selected file name
    const [isDragging, setIsDragging] = useState(false); // Track drag state
    const user = useSelector(selectUser);

    const [selectedFile, setSelectedFile] = useState(null);
    const [uploadError, setUploadError] = useState("");
    const [uploadSuccess, setUploadSuccess] = useState("");
    const [showZipModal, setShowZipModal] = React.useState({ status: false, zips: [] });

    // const [uploadCompanyWideAbsence] = useUploadCompanyWideAbsenceMutation();
    const [uploadCompanyWideAbsence] = useUploadCompanyWideAbsenceMutation();
    const [uploadAvailability] = useUploadProviderAvailabilityMutation();

    const handleSelect = (type) => {
        setSelectedType(type);
    };

    const handleFileClick = (e) => {
        if (e) e.stopPropagation();
        fileInputRef.current.click(); // Open file dialog
    };

    const handleFileChange = (e) => {
        if (e.target.files.length > 0) {
            const file = e.target.files[0];
            setFileName(file.name);
            setSelectedFile(file);
            setUploadError("");
            setUploadSuccess("");
        }
    };

    // Handle drag events
    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragEnter = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        // Only set dragging to false if leaving the drop zone itself, not child elements
        if (e.currentTarget.contains(e.relatedTarget)) return;
        setIsDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);

        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            const file = e.dataTransfer.files[0];
            processFile(file);
            e.dataTransfer.clearData();
        }
    };

    // Process the selected file
    const processFile = (file) => {
        // Validate file type
        const allowedExtensions = ['.xlsx', '.xls', '.csv'];
        const fileExtension = file.name.toLowerCase().slice(file.name.lastIndexOf('.'));

        if (!allowedExtensions.includes(fileExtension)) {
            showAlert("Please select a valid file format (.xlsx, .xls, .csv).");
            return;
        }

        setFileName(file.name);
        setSelectedFile(file);
        setUploadError("");
        setUploadSuccess("");
    };



    // Function to download provider availability template as CSV
    const downloadAvailabilityTemplate = () => {
        // CSV content for provider availability
        const csvContent = `Provider ID,Working Days,Day Start,Day End,Appointment Type IDs,Zip Codes,Market
            141,"MONDAY,TUESDAY,WEDNESDAY",9:00 AM,5:00 PM,"24,59,61,62,052","28482-2839,39594","FL"`;


        // Create blob and download
        // const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const blob = new Blob([csvContent], { type: 'application/vnd.ms-excel;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', 'provider_availability_template.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // Function to download company absences template as CSV
    const downloadAbsencesTemplate = () => {
        // CSV content for company absences
        const csvContent = `Absence Type,Absence Name,Start Date,End Date
            Holiday,New Year's Day,\t02/02/2024,\t02/02/2024`;

        // Create blob and download
        // const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const blob = new Blob([csvContent], { type: 'application/vnd.ms-excel;charset=utf-8;' });

        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', 'company_absences_template.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleUpload = async () => {
        // Reset messages
        setUploadError("");
        setUploadSuccess("");

        // Validate file selection
        if (!selectedFile) {
            showAlert("Please select a file to upload.");
            return;
        }

        // Validate file type
        const allowedExtensions = ['.xlsx', '.xls', '.csv'];
        const fileExtension = selectedFile.name.toLowerCase().slice(selectedFile.name.lastIndexOf('.'));
        if (!allowedExtensions.includes(fileExtension)) {
            showAlert("Please select a valid file format (.xlsx, .xls, .csv).");
            return;
        }

        try {
            // Create FormData and append the file

            // Call the upload mutation
            const result = selectedType === 'availability' ?
                await uploadAvailability({ file: selectedFile, organisationId: user.organisation.id })?.unwrap() : await uploadCompanyWideAbsence({ file: selectedFile, organisationId: user.organisation.id }).unwrap();

            // Handle success

            if (result?.data?.failed?.length > 0) {
                // showAlert(result?.data?.failed?.join(""))
                setShowZipModal({ status: true, errs: result?.data?.failed })
            } else {
                showAlert("File uploaded successfully!", "success");
                onClose();
            }
            // Optionally close the modal after successful upload
            // setTimeout(() => {
            //     onClose();
            // }, 2000);
            fetchProviders();

        } catch (error) {
            // Handle error
            console.error("Upload failed:", error);
            showAlert(
                error.data?.message ||
                error.error ||
                "Failed to upload file. Please try again."
            );
            // fetchProviders();
        }
    };
    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-5 z-50">
            <ReusableModal
                open={showZipModal?.status}
                title="File Upload Errors"
                onClose={() => {
                    setShowZipModal({ status: false, errs: [] })
                }}
                isError={true}
            >
                <div className="min-w-[45vw] max-w-[45vw] p-3 ">
                    <h2 className="text-lg font-semibold mb-3">Errors</h2>
                    <div
                        className="text-gray-700 max-h-[400px] overflow-y-auto p-2 rounded-md border border-gray-200 bg-gray-50"
                    >
                        {showZipModal?.errs?.length > 0 ? (
                            <div className="space-y-1">
                                {showZipModal.errs.map((err, index) => (
                                    <p key={index} className="text-red-600 m-0 break-words">
                                        {selectedType === 'availability' ? err : err?.error}
                                    </p>
                                ))}
                            </div>
                        ) : (
                            <p className="text-gray-500 italic">No errors found.</p>
                        )}
                    </div>
                </div>
            </ReusableModal>
            <div className="bg-white rounded-lg max-w-[800px] w-[90vw] max-h-[90vh] flex flex-col shadow-2xl">
                {/* Header */}
                <div
                    className="bg-gradient-to-r from-green-600 to-emerald-500 text-white flex justify-between items-center px-4 py-3 rounded-t-lg flex-shrink-0">
                    <div className="text-md font-semibold flex items-center gap-2">
                        ↑ Bulk Upload Provider Schedules
                    </div>
                    <button onClick={onClose} className="text-white text-sm hover:text-gray-200 transition">
                        ✕
                    </button>
                </div>

                {/* Scrollable Content */}
                <div className="p-6 space-y-8 overflow-y-auto flex-1 no-scrollbar">
                    {/* Upload Section */}
                    <div>
                        <div className="text-base font-semibold text-gray-800 mb-2">
                            What would you like to upload?
                        </div>
                        <div className="text-sm text-gray-500 mb-3">
                            Choose the type of data you want to bulk upload.
                        </div>

                        <div className="grid grid-cols-2 gap-4">
                            {/* <div
                        className="border-2 border-dotted border-gray-300 rounded-lg p-5 text-center cursor-pointer hover:border-green-600 hover:bg-green-50 transition">
                        <div className="text-3xl mb-2">📅</div>
                        <div className="font-semibold text-gray-800">
                            Provider Availability
                        </div>
                        <div className="text-xs text-gray-500 mt-1">
                            Upload daily availability
                        </div>
                    </div>

                    <div
                        className="border-2 border-dotted border-gray-300 rounded-lg p-5 text-center cursor-pointer hover:border-green-600 hover:bg-green-50 transition">
                        <div className="text-3xl mb-2">🚫</div>
                        <div className="font-semibold text-gray-800">
                            Provider Absences
                        </div>
                        <div className="text-xs text-gray-500 mt-1">
                            Upload leave and unavailability
                        </div>
                    </div> */}
                            <div className={`border-2 rounded-lg py-4 px-5 text-center cursor-pointer transition
                        ${selectedType === "availability" ? "border-green-600 border-solid bg-green-50"
                                    : "border-dotted border-gray-300 hover:border-green-600 hover:bg-green-50"}`} onClick={() =>
                                        handleSelect("availability")}
                            >
                                {/* <div class="upload-option-icon">👤</div> */}
                                <PersonIcon />

                                <div className="font-semibold text-gray-800">Provider Availability</div>
                                <div className="text-xs text-gray-500 mt-1">Upload individual provider schedules and working
                                    hours</div>
                            </div>
                            <div className={`border-2 rounded-lg py-4 px-5 text-center cursor-pointer transition
                        ${selectedType === "absences" ? "border-green-600 border-solid bg-green-50"
                                    : "border-dotted border-gray-300 hover:border-green-600 hover:bg-green-50"}`} onClick={() =>
                                        handleSelect("absences")}>
                                <BusinessIcon />
                                <div className="font-semibold text-gray-800">Company-Wide Absences</div>
                                <div className="text-xs text-gray-500 mt-1">Upload holidays, office closures, and company events
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Download Template Section */}
                    <div className="bg-gray-50 border border-gray-200 rounded-lg p-3">
                        <div className="flex justify-between items-center mb-3">
                            <div className="font-semibold text-gray-800 flex items-center gap-2">
                                ⎙ Download Template
                            </div>
                            <div className="text-sm text-gray-500">
                                Download the appropriate template for your upload type
                            </div>
                        </div>

                        <div className="flex flex-col gap-2">
                            {selectedType === "availability" &&
                                <div className="flex justify-between items-center bg-white border border-gray-200 rounded-md p-3">
                                    <div>
                                        <div className="font-semibold text-gray-800">
                                            Provider Availability Template
                                        </div>
                                        <div className="text-xs text-gray-500">
                                            Includes columns for Provider ID, Working Days, Day Start, Day End, Appointment Type IDs, Zip Codes and Market
                                        </div>
                                    </div>
                                    <button
                                        className="bg-blue-600 text-white text-xs px-3 py-1.5 rounded hover:bg-blue-700 transition"
                                        onClick={downloadAvailabilityTemplate}
                                    >
                                        Download
                                    </button>
                                </div>}
                            {selectedType === "absences" &&
                                <div className="flex justify-between items-center bg-white border border-gray-200 rounded-md p-3">
                                    <div>
                                        <div className="font-semibold text-gray-800">
                                            Company-Wide Absences Template
                                        </div>
                                        <div className="text-xs text-gray-500">
                                            Includes columns for Absence Type, Absence Name, Start Date and End Date
                                        </div>
                                    </div>
                                    <button
                                        className="bg-blue-600 text-white text-xs px-3 py-1.5 rounded hover:bg-blue-700 transition"
                                        onClick={downloadAbsencesTemplate}
                                    >
                                        Download
                                    </button>
                                </div>
                            }
                            {!selectedType && (
                                <div className="bg-gray-50 border border-dashed border-gray-300 rounded-md p-3 text-center text-sm text-gray-500">
                                    Please select a template type to continue.
                                </div>
                            )}
                        </div>
                    </div>

                    {/* File Drop Zone */}
                    <div
                        className={`border-2 rounded-lg p-8 text-center cursor-pointer transition
                            ${isDragging
                                ? 'border-green-700 border-solid bg-green-100'
                                : 'border-dotted border-green-600 bg-green-50 hover:bg-green-50'
                            }`}
                        onDragOver={handleDragOver}
                        onDragEnter={handleDragEnter}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                    // onClick={handleFileClick}
                    >

                        <div class="text-green-600 text-4xl mb-3"> {isDragging ? "↓" : "⎗"}</div>
                        <div class="text-base  text-green-600 font-semibold  mb-2">
                            Drop your file here
                        </div>
                        <div class="text-sm  text-green-600 text-gray-600 mb-3">
                            or click to browse and select a file
                        </div>
                        <div class="text-xs text-gray-500 mb-4">
                            <span className=" font-semibold">Supported formats:</span> .xlsx, .xls, .csv
                        </div>
                        <button
                            class="px-4 py-2 rounded-md bg-white hover:bg-gray-300 text-gray-800 text-sm font-medium transition border border-gray-800"
                            onClick={handleFileClick}>
                            Choose File
                        </button>
                        {fileName && (
                            <div className="mt-2 text-xs text-gray-700">
                                <span className="text-sm font-semibold">Selected file:</span> {fileName}
                            </div>
                        )}
                        <input type="file" ref={fileInputRef} className="hidden" accept=".xlsx,.xls,.csv"
                            onChange={handleFileChange} />
                    </div>

                </div>

                {/* Footer */}
                <div className="border-t border-gray-200 flex justify-between px-6 py-4 bg-gray-50 rounded-b-lg flex-shrink-0">
                    <button onClick={onClose}
                        className="px-4 py-2 rounded-md border text-gray-700 border-gray-300 hover:bg-gray-100 text-sm font-medium">
                        Cancel
                    </button>
                    <button
                        className="px-4 py-2 rounded-md bg-green-600 text-white hover:bg-green-700 text-sm font-medium disabled:opacity-50"
                        onClick={handleUpload}
                        disabled={!selectedFile || !user?.permissions?.includes('provider_settings.bulk_provider_availability')}
                    >
                        Upload
                    </button>
                </div>
            </div>
        </div>
    );
}